import React from 'react';
import styles from './Blog.module.css';

import one from '../../Images/blogs/1.png';
import two from '../../Images/blogs/2.png';
import three from '../../Images/blogs/3.png';
import four from '../../Images/blogs/4.png';
import five from '../../Images/blogs/5.png';
import six from '../../Images/blogs/6.png';
import seven from '../../Images/blogs/7.png';
// import eight from '../../Images/blogs/8.png';
import nine from '../../Images/blogs/9.png';

const Blog = () => {

  const blogData = {
    featured: {
      image: one,
      title: "Revolutionizing Customer Calls with AI Assistants",
      description:
        "Discover how AI-powered voice agents are transforming industries like healthcare, hospitality, real estate, and education. From booking appointments to answering customer queries 24/7, learn how AI is reshaping communication.",
    },
    posts: [
      {
        image: one,
        title: "Inbound vs Outbound AI Calls",
        description:
          "Learn the difference between inbound and outbound AI calls and how businesses can leverage them to streamline customer service and boost engagement.",
        author: "Toolbox Team",
        date: "Jan 24, 2024",
      },
      {
        image: two,
        title: "How AI Voice Bots Work in Real Time",
        description:
          "Explore the real-time functioning of AI voice bots and how natural language processing powers seamless customer conversations.",
        author: "Toolbox Team",
        date: "Jan 24, 2024",
      },
      {
        image: three,
        title: "AI Agents for Healthcare Industry",
        description:
          "Discover how AI-powered agents are revolutionizing the healthcare sector by offering 24/7 assistance, appointment scheduling, and patient monitoring.",
        author: "Toolbox Team",
        date: "Jan 24, 2024",
      },
      {
        image: four,
        title: "Hospitality Meets AI: Better Guest Experience",
        description:
          "See how hotels and resorts are using AI to enhance the guest experience, automate check-ins, and provide instant room service through smart assistants.",
        author: "Toolbox Team",
        date: "Jan 24, 2024",
      },
      {
        image: five,
        title: "AI Voice Agents in Real Estate",
        description:
          "From virtual tours to answering property queries, AI voice agents are changing how real estate professionals engage with potential buyers and renters.",
        author: "Toolbox Team",
        date: "Jan 24, 2024",
      },
      {
        image: six,
        title: "Education & AI: Automated Learning Assistants",
        description:
          "Explore how AI is transforming education with interactive voice bots that help students learn, revise, and get answers in real time.",
        author: "Toolbox Team",
        date: "Jan 24, 2024",
      },
      {
        image: seven,
        title: "Securing AI Conversations: Privacy First",
        description:
          "Learn how companies are securing AI-powered conversations to comply with privacy laws and protect sensitive customer data.",
        author: "Toolbox Team",
        date: "Jan 24, 2024",
      },
      {
        image: nine,
        title: "Customer Support Revolution with AI",
        description:
          "How AI-driven customer support systems are reducing wait times, improving satisfaction, and offering scalable support around the clock.",
        author: "Toolbox Team",
        date: "Jan 24, 2024",
      },
      {
        image: nine,
        title: "Retail Gets Smarter with Voice AI",
        description:
          "See how retail businesses are adopting AI voice assistants to help customers find products, track orders, and get personalized shopping advice.",
        author: "Toolbox Team",
        date: "Jan 24, 2024",
      },
    ],
  };


  return (
    <div className={styles.blogContainer}>
      <div className={styles.featured}>
        <img src={blogData.featured.image} alt="Featured" className={styles.featuredImage} />
        <div className={styles.featuredContent}>
          <div className={styles.feature}>
          <h3 className={styles.featuredLabel}>Featured</h3>
          <h2>{blogData.featured.title}</h2>
          <p>{blogData.featured.description}</p>
          </div>
        </div>
      </div>

      {/* Blog Grid */}
      <h3 className={styles.recentTitle}>Recent Blog Post</h3>
      <div className={styles.blogGrid}>
        {blogData.posts.map((post, index) => (
          <div key={index} className={styles.card}>
            <img src={post.image} alt="Blog" className={styles.cardImage} />
            <h4>{post.title}</h4>
            <p>{post.description}</p>
          <div className={styles.metaBox}>
         <img src={post.image} alt="Blog" className={styles.profileImage} /> <div>{post.author} | 📅 {post.date}</div>
          </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
